import {createConfig as createBestHouseholdPicksConfig} from '../besthouseholdpicks/config'

const localeConfigs = {
  us: {
    measurementId: 'G-P6R5M5W6HB',
  },
}

export const createConfig = (locale: string = 'us') => {
  const normalizedLocale = locale.toLowerCase()
  const bestHouseholdPicksConfig = createBestHouseholdPicksConfig(normalizedLocale)
  const localeConfig = localeConfigs[normalizedLocale as keyof typeof localeConfigs] || {}

  return {
    ...bestHouseholdPicksConfig,
    ...localeConfig,
  }
}
